import {
    all,
    fork,
    put,
    takeLatest,
    select
} from 'redux-saga/effects';
import {redirect} from 'redux-first-router';
import {get} from 'lodash';

import {
    FETCH_USER_SUCCESS,
    LOGOUT_ACTION,
    FETCH_USER_FAILURED
} from '.';
import {
    bootFinished
} from '../app';
import {
    ROUTE_LOGIN,
    ROUTE_HOME
} from '../routing';

function* redirectAwayAfterUserLogin() {
    yield takeLatest(FETCH_USER_SUCCESS, function* (action) {
        const {location} = yield select();
        let redirectType = get(location, 'type', '');
        const payload = get(location, 'payload', '');
        const query = get(location, 'query', '');

        // Được phép đi tiếp
        yield put(redirect({
            type: redirectType && redirectType !== ROUTE_LOGIN ? redirectType : ROUTE_HOME,
            payload,
            query
        }));
        
    });

    yield takeLatest(FETCH_USER_FAILURED, function* (action) {
        const {location} = yield select();
        let redirectType = get(location, 'type', '');
        const payload = get(location, 'payload', '');
        const query = get(location, 'query', '');

        yield put(bootFinished());
        yield put(redirect({
            type: redirectType && redirectType !== ROUTE_LOGIN ? ROUTE_LOGIN : redirectType,
            payload,
            query
        }));
    });
}

function* logout() {
    const {location} = yield select();
    if (process.env.REACT_APP_ENV === 'local') {
        yield put(redirect({
            type: ROUTE_LOGIN,
            query: location.type !== ROUTE_LOGIN ? {redirect: location.type} : {}
        }));
    } else {
        window.location.pathname = "/login";
    }
}

export default function* auth() {
    yield all([
        takeLatest(LOGOUT_ACTION, logout),
        fork(redirectAwayAfterUserLogin)
    ]);
}
